import React, { memo } from 'react';
import PropTypes from 'prop-types';
import PatternTheme from '@mlb/react-patterns/v4/components/Theme/theme.tsx';
import { ThemeProvider } from '@mlb/react-patterns/components/ThemeProvider/ThemeProvider.tsx';
import AutoStyles from '../themes/auto';
import { createGlobalStyle } from 'styled-components';

const Auto = createGlobalStyle`${AutoStyles}`;
const Theme = ({
    enableDarkMode = false,
    themeMode,
    children
}) => {
    return (
        <PatternTheme>
            <ThemeProvider theme={{ type: themeMode }}>
                <Auto themeMode={themeMode} enableDarkMode={enableDarkMode} />
                {children}
            </ThemeProvider>
        </PatternTheme>
    );
};

Theme.propTypes = {
    children: PropTypes.any,
    enableDarkMode: PropTypes.bool,
    themeMode: PropTypes.string,
    auto: PropTypes.bool
};

export default memo(Theme);
